import { createBodyToCheck, formatTasks } from '#helpers'
import axios from 'axios'
import applyCaseMiddleware from 'axios-case-converter'
import useSWR from 'swr'
const { baseURL, nonce, partnerKey, accessToken, uuid, pluginDir } =
  window.marketgoo

// TODO: Pending replace _marketgoo-development with variable
const description = `_${pluginDir}_${uuid}_description`
const keyword = `_${pluginDir}_${uuid}_keyword`
const keywordId = `_${pluginDir}_${uuid}_keywordId`
const score = `_${pluginDir}_${uuid}_score`

// TODO: Pending to remove selectors and implement it on usePost directly
export const selectors = {
  description,
  keyword,
  keywordId,
}

export const request = applyCaseMiddleware(
  axios.create({
    baseURL,
    headers: {
      [`${partnerKey}-authorization`]: `Bearer ${accessToken}`,
      'X-WP-Nonce': nonce || false,
    },
  }),
  {
    ignoreHeaders: true,
    preservedKeys: ['keywordId', description, keyword, keywordId, score],
  }
)

const GET = 'GET'
const POST = 'POST'

const metatagsGenerator = {
  create: ({ url, keyword }) => ({
    url: `${partnerKey}/v1/metatags/autocomplete`,
    method: POST,
    data: { url, keyword },
  }),
}

const checks = {
  create: (body) => ({
    url: `${partnerKey}/v1/checks`,
    method: POST,
    data: body,
  }),
  get: (id) => ({
    url: `${partnerKey}/v1/checks/${id}`,
    method: GET,
  }),
}

// keywords: caballo
const keywordSearch = {
  get: (keywords) => ({
    url: `${partnerKey}/v1/keyword-search`,
    method: POST,
    data: keywords,
  }),
}

const meta = {
  create: ({ postId, data }) => ({
    url: `${partnerKey}/v1/page/create/${postId}/meta`,
    method: POST,
    data,
  }),
}

const ctas = {
  read: () => ({ url: `${partnerKey}/v1/ctas`, method: GET }),
}

const dataAccount = {
  get: () => ({ url: `${partnerKey}/v1/data`, method: GET }),
}

const wpNS = '/wp/v2'
const popTypes = {
  page: 'pages',
  post: 'posts',
}

const posts = {
  get: (id) => ({
    url: id ? `${wpNS}/posts/${id}` : `${wpNS}/posts`,
    method: GET,
  }),
  edit: ({ postId, data } = {}) => ({
    url: `${wpNS}/posts/${postId}`,
    method: POST,
    data,
  }),
}

const pop = {
  get: ({ id, type }) => ({
    url: `${wpNS}/${popTypes[type]}/${id}`,
    method: GET,
  }),
  edit: ({ id, type, data } = {}) => ({
    url: `${wpNS}/${popTypes[type]}/${id}`,
    method: POST,
    data,
  }),
}

const pages = {
  get: (id) => ({
    url: id ? `${wpNS}/pages/${id}` : `${wpNS}/pages`,
    method: GET,
  }),
}

export { usePop } from './usePop'
export { useTasks } from './useTasks'
export { useCtas } from './useCtas'
export { useProductDetails } from './useProductDetails'
export { useSiteConfig } from './useSiteConfig'

export const endpoints = {
  metatagsGenerator,
  checks,
  ctas,
  dataAccount,
  keywordSearch,
  meta,
  pages,
  pop,
  posts,
}
